import { render } from "./RevenuesReport.vue?vue&type=template&id=1f254641&scoped=true"
import script from "./RevenuesReport.vue?vue&type=script&lang=js"
export * from "./RevenuesReport.vue?vue&type=script&lang=js"

import "./RevenuesReport.vue?vue&type=style&index=0&id=1f254641&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f254641"]])

export default __exports__